import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import {FormBuilder, FormGroup, Validators, ValidationErrors} from '@angular/forms';
import {HttpService} from '../../service/http.service';
declare var $: any;

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit, OnDestroy {

  enterpriseContact: FormGroup;
  disabled = true;

  @ViewChild('modalWindow', { static: false })
  private modal: ElementRef;

  constructor(
    private fb: FormBuilder,
    private http: HttpService
  ) { }

  ngOnInit() {
    this.enterpriseContact = this.fb.group({
      name: ['', Validators.compose([Validators.required])],
      organization: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required])],
      phone: ['', Validators.compose([Validators.required])],
      reason: ['', Validators.compose([Validators.required])],
      description: ['', Validators.compose([Validators.required])],
      size: ['', Validators.compose([Validators.required])],
    });
    this.enterpriseContact.valueChanges.subscribe((x) => {
      this.disabled = this.getFormValidationErrors();
    });
  }

  get f() { return this.enterpriseContact.controls; }

  getFormValidationErrors() {
    const errors = [];
    Object.keys(this.enterpriseContact.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.enterpriseContact.get(key).errors;
      if (controlErrors != null) {
        errors.push(controlErrors);
      }
    });
    return errors.length > 0;
  }

  submitEnterpriseRequest($event) {
    this.http.submitEnterpriseContact(this.enterpriseContact.value).subscribe((x) => {
      console.log('Response', x);
      if (x.status) {
        $('#enterprise-contact').modal('hide');
      } else {
        alert(x.message);
      }
    });
  }

  ngOnDestroy() {
    $('#enterprise-contact').modal('hide');
  }

}
